module.exports = __webpack_public_path__ + "img/magic-line-long.7ef45507.svg";